import iconBoost from '../assets/icons/icon-boost.svg';
import iconCredits from '../assets/icons/icon-credits.svg';
import iconCrown from '../assets/icons/icon-crown.svg';
import iconDashboard from '../assets/icons/icon-dashboard.svg';
import iconDayProfile from '../assets/icons/icon-day-profile.svg';
import iconDiamond from '../assets/icons/icon-diamond.svg';
import iconEye from '../assets/icons/icon-eye.svg';
import iconIncognito from '../assets/icons/icon-incognito.svg';
import iconInfinity from '../assets/icons/icon-infinity.svg';
import iconLogOff from '../assets/icons/icon-log-off.svg';
import iconMessage from '../assets/icons/icon-message.svg';
import iconMoney from '../assets/icons/icon-money.svg';
import iconNotify from '../assets/icons/icon-notify.svg';
import iconRecommandet from '../assets/icons/icon-recommandet.svg';
import iconReport from '../assets/icons/icon-report.svg';
import iconStar from '../assets/icons/icon-star.svg';
import iconStarWhite from '../assets/icons/icon-star-white.svg';
import iconStats from '../assets/icons/icon-stats.svg';
import iconTicket from '../assets/icons/icon-ticket.svg';
import iconTop from '../assets/icons/icon-top.svg';
import iconTrophy from '../assets/icons/icon-trophy.svg';
import iconUndo from '../assets/icons/icon-undo.svg';
import iconUpsensePlus from '../assets/icons/icon-upsense-plus.svg';
import iconUser from '../assets/icons/icon-user.svg';
import iconVerify from '../assets/icons/icon-verify.svg';

const ICONS = {
  boost: iconBoost,
  credits: iconCredits,
  crown: iconCrown,
  dashboard: iconDashboard,
  'day-profile': iconDayProfile,
  diamond: iconDiamond,
  eye: iconEye,
  incognito: iconIncognito,
  infinity: iconInfinity,
  'log-off': iconLogOff,
  message: iconMessage,
  money: iconMoney,
  notify: iconNotify,
  recommandet: iconRecommandet,
  report: iconReport,
  star: iconStar,
  'star-white': iconStarWhite,
  stats: iconStats,
  ticket: iconTicket,
  top: iconTop,
  trophy: iconTrophy,
  undo: iconUndo,
  'upsense-plus': iconUpsensePlus,
  user: iconUser,
  verify: iconVerify,
} as const;

export type IconName = keyof typeof ICONS;

interface Props {
  name: IconName;
  className?: string;
  size?: number;
}

/**
 * Brand line icon (fialová #9616FF, line style, single color).
 * Použitie: <Icon name="boost" /> alebo <Icon name="message" size={24} className="..." />.
 * Default veľkosť je riadená cez CSS class `.ic` (18px). Voliteľne sa dá override-nuť `size` props alebo CSS.
 */
export function Icon({ name, className = '', size }: Props) {
  const sizeStyle = size ? { width: size, height: size } : undefined;
  return (
    <img
      src={ICONS[name]}
      alt=""
      aria-hidden="true"
      className={`ic ${className}`.trim()}
      style={sizeStyle}
    />
  );
}
